import { useEffect } from 'react';
import { A2UIProvider, A2UIRenderer, useA2UI } from '@a2ui/react/v0_8';

function A2UIHydrate({ surfaceId, messages, onProcessMessagesError }) {
  const { processMessages } = useA2UI();

  useEffect(() => {
    try {
      processMessages(messages);
    } catch (err) {
      onProcessMessagesError?.(err);
    }
  }, [processMessages, surfaceId, messages, onProcessMessagesError]);

  return <A2UIRenderer surfaceId={surfaceId} className="chat-a2ui-surface" />;
}

/**
 * 每則機器人回覆獨立 Provider：餵入 v0.8 訊息序列並渲染對應 surface。
 */
export default function A2UIReplySurface({ surfaceId, messages, onClientAction, onProcessMessagesError }) {
  return (
    <A2UIProvider onAction={onClientAction}>
      <A2UIHydrate
        surfaceId={surfaceId}
        messages={messages}
        onProcessMessagesError={onProcessMessagesError}
      />
    </A2UIProvider>
  );
}
